import ChoiceCard from '../../components/CardQuestionAI/ChoiceCard/ChoiceCard';
import FileCard from '../../components/CardQuestionAI/FileCard/FileCard';
import TextCard from '../../components/CardQuestionAI/TextCard/TextCard';
import WriteCard from '../../components/CardQuestionAI/WriteCard/WriteCard';
import CodeCard from '../../components/CardQuestionAI/CodeCard/CodeCard';
import { AnswerTypeEnum, StrategyValues } from '../../constants/enums';

export function getStrategyAnswerCardByType({
  type,
  data,
  index,
  handleDelete,
  dataAI,
  setDataAI,
  strategy = StrategyValues.NORMAL,
}) {
  switch (type) {
    case AnswerTypeEnum.CHECK:
      return (
        <ChoiceCard
          key={index}
          index={index + 1}
          answers={data.answers}
          question={data.question}
          id={data.id}
          handleDelete={handleDelete}
          setDataAI={setDataAI}
        />
      );

    case AnswerTypeEnum.WRITE:
      return (
        <WriteCard
          key={index}
          index={index + 1}
          answer={data.answer}
          question={data.question}
          id={data.id}
          handleDelete={handleDelete}
          dataAI={dataAI}
          setDataAI={setDataAI}
        />
      );
    case AnswerTypeEnum.TEXT:
      return (
        <TextCard
          key={index}
          index={index + 1}
          maxChar={data.maxChar}
          question={data.question}
          id={data.id}
          handleDelete={handleDelete}
          setDataAI={setDataAI}
        />
      );
    case AnswerTypeEnum.TEXT_AI:
      return (
        <TextCard
          key={index}
          index={index + 1}
          maxChar={data.maxChar}
          question={data.question}
          concepts={data.concepts}
          id={data.id}
          handleDelete={handleDelete}
          setDataAI={setDataAI}
          textAIType
          strategy={strategy}
          totalTime={data.totalTime}
        />
      );
    case AnswerTypeEnum.FILE:
      return (
        <FileCard
          key={index}
          index={index + 1}
          question={data.question}
          types={data.types}
          id={data.id}
          handleDelete={handleDelete}
          setDataAI={setDataAI}
        />
      );
    case AnswerTypeEnum.CODE_AI:
      return (
        <CodeCard
          key={index}
          index={index + 1}
          question={data.question}
          preCode={data.preCode}
          id={data.id}
          handleDelete={handleDelete}
          setDataAI={setDataAI}
        />
      );
    default:
      return null;
  }
}
